<template>
	<div>
		<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
			<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">{{partText}}</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.name}}</b></div>
			<div class="action-container">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							small
							color="#959595"
							@click="toClientChat"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon dark small>mdi-chat</v-icon>
						</v-btn>
					</template>
					<span>Chatear con Cliente</span>
				</v-tooltip>
				<v-menu
					v-if="!isSubcontractor"
					v-model="userCompanyMenu"
					offset-y
					nudge-left="350px"
					z-index="9999"
					:close-on-content-click="false"
					content-class="menu-bg-white"
					style="z-index: 9999; background-color: white;"
					open-on-hover
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							:color="partInfo?.company_profile ?'#FF1209':'grey'"
							x-small
							v-bind="attrs"
							v-on="on"
							@mouseenter="openUserCompanyMenu"
							@mouseleave="closeMenuWithDelay"
						>
							<v-icon dark small>{{partInfo?.company_profile ?'mdi-domain':'mdi-account'}}</v-icon>
						</v-btn>
					</template>
					<v-card min-width="400px"
							@mouseenter="openUserCompanyMenu"
							@mouseleave="closeMenuWithDelay">
						<v-card-text>
							<div class="caption">
								<p class="mb-0 font-weight-bold">{{partText}} {{ partInfo?.company_profile ? 'Empresa':'Persona Natural' }}</p>
								<div v-if="partInfo?.company_profile">
									<v-divider class="my-2"></v-divider>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Usuario</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.account_user_name}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email Usuario</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.account_user_email}}</b></div>
								</div>
								<v-divider class="my-2"></v-divider>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.name}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rut | formatRut}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.email}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.phone}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.address}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Comuna</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.city}}</b></div>
								<div v-if="partInfo?.company_profile">
									<v-divider class="my-1"></v-divider>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rep_name}} {{partInfo.rep_first_lname}} {{partInfo.rep_second_lastname}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.email}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rep_rut | formatRut}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rep_address}}</b></div>
									<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Comuna R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rep_city}}</b></div>
								</div>
							</div>
						</v-card-text>
					</v-card>
				</v-menu>
			</div>
		</div>
		<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!isSubcontractor">
			<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.rut | formatRut}}</b></div>
			<div class="action-container">
			</div>
		</div>
		<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!isSubcontractor">
			<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.email}}</b></div>
			<div class="action-container">
			</div>
		</div>
		<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="!isSubcontractor">
			<div class="d-flex justify-space-between caption" style="width: 100%"><div style="width: 100px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{partInfo.phone}}</b></div>
			<div class="action-container">
			</div>
		</div>
	</div>
</template>


<script>
import {createUserChatRoom} from '@/helpers/api/chats'

export default {
	name: 'ProjectHeaderInfoClientSubcontractorInfo',
	computed: {
		isSubcontractor(){
			return this.$store.state.user.companyPermissions?.subcontractor === true
		},
		partText(){
			return this.is_subcontract ? 'Subcontratista':'Cliente'
		},
		partInfo(){
			let user_info = {...this.project.client?.profile, ...this.project.client}
			if(this.is_subcontract){
				user_info = this.contract?.contractor
			}
			if(user_info?.company_profile && user_info.accreditation?.status){
				return {
					...user_info?.company_profile,
					account_user_name: user_info?.profile?.name + ' ' + user_info?.profile?.lastname + ' ' + user_info?.profile?.second_lastname,
					account_user_email: user_info?.email,
					name: user_info?.company_profile.name,
					rut: user_info?.company_profile.rut,
					email: user_info?.company_profile.email,
					phone: user_info?.company_profile.phone,
					address: user_info?.company_profile.address,
					city: user_info?.company_profile.city?.name,
					rep_name: user_info?.company_profile.rep_name,
					rep_first_lname: user_info?.company_profile.rep_first_lastname,
					rep_second_lastname: user_info?.company_profile.rep_second_lastname,
					rep_rut: user_info?.company_profile.rep_rut,
					rep_address: user_info?.company_profile.rep_address,
					rep_city: user_info?.company_profile.rep_city?.name,
					company_profile: true
				};
			}
			else{
				return {
					...user_info?.profile,
					name: user_info?.profile.name + ' ' + user_info?.profile.lastname + ' ' + user_info?.profile.second_lastname,
					rut: user_info?.profile.rut,
					email: user_info?.email,
					phone: user_info?.profile.phone,
					city: user_info?.profile.city?.name,
					company_profile: false
				};
			}
    }
	},
	props: {
    is_subcontract: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
	},
	watch: {
	},
	data() {
		return{
			closeTimeout: null,
			userCompanyMenu: false,
		}
	},
	mounted(){
	},
	methods: {
		async toClientChat(){
			if(!this.partInfo?.user_id) return;
			const user_chat = await createUserChatRoom({user_id: this.partInfo.user_id})
			if(user_chat.code == 200){
				window.open(
					`/built-in-content?type=chatroom&id=${user_chat.chat_room.id}`,
					'',
					'width=550,height=700,toolbar=no,menubar=no,location=no,status=no'
				);
			}
		},
		openUserCompanyMenu(){
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
			this.userCompanyMenu = true
		},
    closeMenuWithDelay() {
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
      this.closeTimeout = setTimeout(() => {
        this.userCompanyMenu = false
        this.closeTimeout = null
      }, 150)
    },
	}
}
</script>

<style scoped>
.action-container{
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.item-background-hover:hover .action-container {
  opacity: 1;
}
</style>